import { useState } from "react";
import { Link } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import SEOHead from "@/components/feature/SEOHead";
import ScrollToTop from "@/components/feature/ScrollToTop";
import { categories, featuredContent, latestContent, faqList } from "@/mocks/content";

const statsData = [
  { value: "10万+", label: "正版资源" },
  { value: "5000万+", label: "累计用户" },
  { value: "99.9%", label: "播放成功率" },
  { value: "24h", label: "同步更新" },
];

const advantages = [
  {
    icon: "ri-shield-check-line",
    title: "正版授权",
    desc: "所有内容均获日本、韩国版权方正版授权，放心观看",
  },
  {
    icon: "ri-4k-line",
    title: "超高清画质",
    desc: "支持4K超高清播放，HDR画质增强，视觉盛宴",
  },
  {
    icon: "ri-device-line",
    title: "多终端同步",
    desc: "Web、iOS、Android、智能电视全覆盖，无缝切换",
  },
  {
    icon: "ri-refresh-line",
    title: "每日更新",
    desc: "日韩剧集播出后24小时内更新，绝不错过精彩",
  },
];

export default function Home() {
  const [activeFaq, setActiveFaq] = useState<number | null>(null);

  const homeSchema = [
    {
      "@context": "https://schema.org",
      "@type": "Organization",
      name: "aaa日韩",
      url: "https://www.aaark.com",
      description: "aaa日韩官方正版授权平台，汇聚海量日韩优质内容资源",
      foundingDate: "2020",
    },
    {
      "@context": "https://schema.org",
      "@type": "WebSite",
      name: "aaa日韩",
      url: "https://www.aaark.com",
      potentialAction: {
        "@type": "SearchAction",
        target: "https://www.aaark.com/search?q={search_term_string}",
        "query-input": "required name=search_term_string",
      },
    },
    {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: faqList.map((faq) => ({
        "@type": "Question",
        name: faq.question,
        acceptedAnswer: {
          "@type": "Answer",
          text: faq.answer,
        },
      })),
    },
  ];

  return (
    <>
      <SEOHead
        title="aaa日韩官方入口·正版授权平台 - aaa日韩在线高清最新资源"
        description="aaa日韩是您探索日韩优质内容的首选平台，汇聚海量日韩正版资源，高清流畅体验，多终端同步播放，每日持续更新，满足您对aaa日韩全方位的内容需求，立即免费体验。"
        keywords="aaa日韩,aaa日韩在线,aaa日韩高清,aaa日韩最新资源,日韩正版内容,日韩高清平台,aaa日韩免费入口"
        canonicalUrl="https://www.aaark.com"
        ogImage="https://readdy.ai/api/search-image?query=Modern%20streaming%20platform%20interface%20with%20Japanese%20and%20Korean%20entertainment%20content%2C%20cinematic%20vibrant%20colors%2C%20clean%20minimal%20design%2C%20dark%20theme%20with%20warm%20accents%2C%20professional%20broadcast%20aesthetic&width=1200&height=630&seq=og-home&orientation=landscape"
        schemaJson={homeSchema}
      />
      <ScrollToTop />

      <div className="min-h-screen bg-background-50">
        <Navbar />

        <main>
          {/* Hero Section */}
          <section className="relative w-full h-[520px] md:h-[620px] overflow-hidden">
            <img
              src="https://readdy.ai/api/search-image?query=Cinematic%20wide%20composition%20of%20Japanese%20ancient%20temple%20blending%20with%20modern%20Tokyo%20skyline%20at%20sunset%2C%20traditional%20Korean%20palace%20with%20Seoul%20cityscape%2C%20dramatic%20warm%20golden%20hour%20lighting%2C%20artistic%20double%20exposure%20style%2C%20ethereal%20atmosphere%2C%20soft%20gradient%20sky%2C%20clean%20elegant%20composition&width=1800&height=700&seq=hero-bg-home&orientation=landscape"
              alt="aaa日韩正版内容平台"
              className="absolute inset-0 w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/35 to-black/60"></div>

            <div className="relative z-10 w-full h-full flex flex-col items-center justify-center px-4 md:px-6 text-center">
              <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold text-white mb-4 leading-tight" style={{ fontFamily: "var(--font-heading)" }}>
                aaa<span className="text-primary-400">日韩</span>官方正版平台
              </h1>
              <p className="text-base md:text-lg text-white/80 max-w-2xl mb-8 leading-relaxed">
                汇聚海量日韩正版资源，高清流畅体验，多终端同步播放，每日持续更新，满足您全方位的内容需求
              </p>
              <div className="flex flex-col sm:flex-row items-center gap-4">
                <Link
                  to="/category/drama"
                  className="px-8 py-3 text-base font-semibold rounded-full bg-primary-500 text-background-50 hover:bg-primary-600 transition-all whitespace-nowrap cursor-pointer shadow-lg shadow-primary-500/25"
                >
                  立即免费体验
                </Link>
                <Link
                  to="/about"
                  className="px-8 py-3 text-base font-medium rounded-full border border-white/30 text-white hover:bg-white/10 transition-all whitespace-nowrap cursor-pointer"
                >
                  了解更多
                </Link>
              </div>

              <div className="mt-10 grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-8">
                {statsData.map((stat) => (
                  <div key={stat.label} className="text-center">
                    <p className="text-2xl md:text-3xl font-bold text-white">{stat.value}</p>
                    <p className="text-xs md:text-sm text-white/60 mt-1">{stat.label}</p>
                  </div>
                ))}
              </div>
            </div>
          </section>

          {/* Advantages */}
          <section className="py-12 md:py-16 bg-background-100">
            <div className="px-4 md:px-6">
              <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
                {advantages.map((adv) => (
                  <div key={adv.title} className="text-center p-5 rounded-lg bg-background-50">
                    <div className="w-12 h-12 mx-auto mb-3 flex items-center justify-center rounded-full bg-primary-100">
                      <i className={`${adv.icon} text-xl text-primary-500`}></i>
                    </div>
                    <h3 className="text-sm font-semibold text-foreground-950 mb-1.5">{adv.title}</h3>
                    <p className="text-xs text-foreground-600 leading-relaxed">{adv.desc}</p>
                  </div>
                ))}
              </div>
            </div>
          </section>

          {/* Category Navigation */}
          <section className="py-14 md:py-20">
            <div className="px-4 md:px-6">
              <div className="text-center mb-10">
                <h2 className="text-2xl md:text-3xl font-bold text-foreground-950" style={{ fontFamily: "var(--font-heading)" }}>
                  内容分类
                </h2>
                <p className="text-sm text-foreground-600 mt-2">探索丰富的日韩正版内容资源</p>
              </div>

              <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4">
                {categories.map((cat) => (
                  <Link
                    key={cat.slug}
                    to={`/category/${cat.slug}`}
                    className="group p-5 rounded-lg bg-background-100 hover:bg-background-200/70 transition-all cursor-pointer text-center"
                  >
                    <div className={`w-12 h-12 mx-auto mb-3 flex items-center justify-center rounded-full bg-gradient-to-br ${cat.color}`}>
                      <i className={`${cat.icon} text-lg text-white`}></i>
                    </div>
                    <h3 className="text-sm font-semibold text-foreground-950 mb-1">{cat.name}</h3>
                    <p className="text-xs text-foreground-500 line-clamp-2">{cat.description}</p>
                  </Link>
                ))}
              </div>
            </div>
          </section>

          {/* Featured Content */}
          <section className="py-14 md:py-20 bg-background-100">
            <div className="px-4 md:px-6">
              <div className="flex items-center justify-between mb-10">
                <div>
                  <h2 className="text-2xl md:text-3xl font-bold text-foreground-950" style={{ fontFamily: "var(--font-heading)" }}>
                    精选推荐
                  </h2>
                  <p className="text-sm text-foreground-600 mt-2">编辑精选的优质日韩内容</p>
                </div>
              </div>

              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
                {featuredContent.map((item) => (
                  <Link
                    key={item.id}
                    to={`/article/${item.id}`}
                    className="group rounded-lg overflow-hidden bg-background-50 hover:bg-background-200/50 transition-all cursor-pointer"
                  >
                    <div className="relative aspect-video overflow-hidden">
                      <img
                        src={item.image}
                        alt={item.title}
                        className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                      />
                      <div className="absolute top-2 left-2 px-2 py-0.5 rounded text-xs font-medium bg-black/60 text-white">
                        {categories.find((c) => c.slug === item.category)?.name}
                      </div>
                      <div className="absolute top-2 right-2 px-2 py-0.5 rounded text-xs font-medium bg-accent-500 text-background-50">
                        {item.rating}
                      </div>
                    </div>
                    <div className="p-4">
                      <h3 className="text-sm font-semibold text-foreground-950 group-hover:text-primary-500 transition-colors line-clamp-1">
                        {item.title}
                      </h3>
                      <p className="text-xs text-foreground-600 mt-1.5 line-clamp-2">{item.description}</p>
                      <p className="text-xs text-foreground-400 mt-2">{item.updateDate} 更新</p>
                    </div>
                  </Link>
                ))}
              </div>
            </div>
          </section>

          {/* Latest Content */}
          <section className="py-14 md:py-20">
            <div className="px-4 md:px-6">
              <div className="flex items-center justify-between mb-10">
                <div>
                  <h2 className="text-2xl md:text-3xl font-bold text-foreground-950" style={{ fontFamily: "var(--font-heading)" }}>
                    最新更新
                  </h2>
                  <p className="text-sm text-foreground-600 mt-2">每日持续更新，精彩不容错过</p>
                </div>
                <Link
                  to="/category/drama"
                  className="text-sm text-primary-500 hover:text-primary-600 font-medium flex items-center gap-1 whitespace-nowrap cursor-pointer"
                >
                  查看全部 <i className="ri-arrow-right-line"></i>
                </Link>
              </div>

              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
                {latestContent.map((item) => (
                  <Link
                    key={item.id}
                    to={`/article/${item.id}`}
                    className="group flex gap-4 p-4 rounded-lg bg-background-100 hover:bg-background-200/70 transition-all cursor-pointer"
                  >
                    <div className="relative w-40 h-24 shrink-0 overflow-hidden rounded-md">
                      <img
                        src={item.image}
                        alt={item.title}
                        className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                      />
                    </div>
                    <div className="flex-1 min-w-0">
                      <h3 className="text-sm font-semibold text-foreground-950 group-hover:text-primary-500 transition-colors line-clamp-1">
                        {item.title}
                      </h3>
                      <div className="flex items-center gap-2 mt-1.5">
                        <span className="text-xs text-accent-500 font-medium">{item.rating}</span>
                        <span className="text-xs text-foreground-400">{item.duration}</span>
                      </div>
                      <p className="text-xs text-foreground-500 mt-1.5">{item.episode}</p>
                      <p className="text-xs text-foreground-400 mt-1">{item.updateDate}</p>
                    </div>
                  </Link>
                ))}
              </div>
            </div>
          </section>

          {/* FAQ */}
          <section className="py-14 md:py-20 bg-background-100">
            <div className="px-4 md:px-6 max-w-3xl mx-auto">
              <div className="text-center mb-10">
                <h2 className="text-2xl md:text-3xl font-bold text-foreground-950" style={{ fontFamily: "var(--font-heading)" }}>
                  常见问题
                </h2>
                <p className="text-sm text-foreground-600 mt-2">关于aaa日韩平台的常见疑问解答</p>
              </div>

              <div className="flex flex-col gap-3">
                {faqList.map((faq, index) => (
                  <div
                    key={index}
                    className="rounded-lg bg-background-50 overflow-hidden"
                  >
                    <button
                      type="button"
                      onClick={() => setActiveFaq(activeFaq === index ? null : index)}
                      className="w-full flex items-center justify-between p-4 text-left cursor-pointer"
                    >
                      <span className="text-sm font-medium text-foreground-950 pr-4">{faq.question}</span>
                      <i
                        className={`text-foreground-400 text-lg transition-transform duration-200 shrink-0 ${
                          activeFaq === index ? "ri-subtract-line" : "ri-add-line"
                        }`}
                      ></i>
                    </button>
                    {activeFaq === index && (
                      <div className="px-4 pb-4">
                        <p className="text-sm text-foreground-600 leading-relaxed">{faq.answer}</p>
                      </div>
                    )}
                  </div>
                ))}
              </div>
            </div>
          </section>

          {/* CTA */}
          <section className="relative py-16 md:py-24 overflow-hidden">
            <img
              src="https://readdy.ai/api/search-image?query=Abstract%20artistic%20Japanese%20wave%20pattern%20with%20modern%20Korean%20geometric%20design%20elements%20blended%20together%2C%20warm%20coral%20and%20gold%20gradient%2C%20soft%20ethereal%20atmosphere%2C%20clean%20minimal%20aesthetic%2C%20digital%20art%20style&width=1600&height=500&seq=cta-bg-home&orientation=landscape"
              alt=""
              className="absolute inset-0 w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/50 to-black/60"></div>

            <div className="relative z-10 text-center px-4 md:px-6">
              <h2 className="text-2xl md:text-3xl font-bold text-white mb-4" style={{ fontFamily: "var(--font-heading)" }}>
                立即开启您的日韩内容之旅
              </h2>
              <p className="text-sm md:text-base text-white/70 mb-8 max-w-xl mx-auto">
                免费注册即可体验海量正版日韩内容，高清流畅，多端同步
              </p>
              <Link
                to="/about"
                className="inline-flex px-8 py-3 text-base font-semibold rounded-full bg-primary-500 text-background-50 hover:bg-primary-600 transition-all whitespace-nowrap cursor-pointer"
              >
                免费体验
              </Link>
            </div>
          </section>
        </main>

        <Footer />
      </div>
    </>
  );
}